// Internal "shadow" support logins use a <name>.support@linearb.io address —
// noise we hide by default in per-org lists.
export const isSupportEmail = (email?: string | null): boolean =>
  (email ?? '').toLowerCase().endsWith('.support@linearb.io')
